module.exports = __webpack_public_path__ + "static/403.7ad1b109.svg";